export default __webpack_public_path__ + "assets/2bdb5595b3f1f2395f7c4750049d12ae.webp";